import He from 'he';

export default {
    data() {
      return {
        fails: null,
        open: null,
        // no need to define all panels
        panels: ['tracker', 'viewProduct', 'signIn', 'addToCart', 'purchase']
      };
    },
    computed: {
        panelsAssoc() {
            // platform settings are always the first panel
            var o = { 'platformSettings' : 0 };
            if(!this.panels || !Array.isArray(this.panels)) {
                return o;
            }

            this.panels.forEach((p,i) => o[p] = i + 1);
            return o;
        }
    },
    watch: {
        fails(val) {
            if(!this.panels || !Array.isArray(this.panels)) {
                return 'Panels array not set';
            }
            var o = [];
            console.debug('fails', val);
            val.forEach(p => { if(this.panelsAssoc[p] != null) { o.push(this.panelsAssoc[p])}});
            this.open = o;
        }
    },
    methods: {
        printCode() {
            console.debug('allCode', this.getAllCode());
        },
        getAllCode(html) {
            return Object.keys(this.code).map(k => ({ title: k, instructions: html ? document.getElementById(`instructions-${k}`)?.innerHTML : document.getElementById(`instructions-${k}`)?.innerText, code: this.code[k] })).filter(c => !!c.instructions)
        },
        copyOpen(id) {
            let code = this.getAllCode(false).map(c => `------------------ ${this.$t('overview.capabilities.' + c.title)} ------------------\n\n` + c.instructions + '\n\n' + He.decode(c.code).replace('%droiid%',id)).join('\n\n');
            console.debug('formatted code', code);
            this.$copyText(code).then((e) => {
             this.$store.dispatch('ui/notify', { text: this.$t('common.code.copied')});
             console.debug(e);
             }, (e) => {
                 this.$store.dispatch('ui/notify', { text: this.$t('common.code.error'), error: true });
                 console.debug(e)
             })
        },
        mailOpen(id) {
            let code = this.getAllCode(false).map(c => `------------------ ${this.$t('overview.capabilities.' + c.title)} ------------------\n\n` + c.instructions + '\n\n' + He.decode(c.code).replace('%droiid%',id)).join('\n\n');
            console.debug('formatted code', code);
            let mailto = `mailto:?subject=${encodeURIComponent('DreamROI: ' + this.$t('tracking.title'))}&body=${encodeURIComponent(code)}`;
            window.open(mailto, '_blank');
        }
    }
  }
